/*
 * Screens validations utils
 */

const utils = function(params) {
  return {
    data: function() {
      return {
        incompleteScreensDev: [
          '5d5f1cbea43f7b0013171121',
          '5d5f1cbf1f79630014238ab2',
          '5d5f17ccd55b28001358a7d3',
          '5d5f17febd60b10013bf0e86',
          '5d5f17f51842a80013b6ac3f',
          '5d5f17ded55b28001358a7e5',
          '5ef6427ebbdb94001a0b0274',
        ],
        incompleteScreensProd: [
          '5d5f2f408f1ede0012c51fab',
          '5d5f2f408f1ede0012c51fad',
          '5d5f2b768f1ede0012c51dd8',
          '5d5f2b889fd288001342e640',
          '5d5f2ba0bd60b10013bf16c2',
          '5ef4c93e15134900195db45f',
          '5e431277ad7835001a999ddc',
        ],
      }
    },
    computed: {
      isIncompleteScreenKustomer() {
        const { articleId } = this.$route.params
        return this.incompleteScreens.includes(articleId)
      },
      incompleteScreens() {
        return this.incompleteScreensDev.concat(this.incompleteScreensProd)
      },
    },
  }
}

export default utils
